import React, { useState } from 'react';
import styled from 'styled-components';
import { asaasService } from '../services/api';

const Container = styled.div`
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
`;

const Button = styled.button`
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 10px 5px;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const Panel = styled.div`
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin: 15px 0;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
`;

const Title = styled.h2`
  color: #333;
`;

const Status = styled.div`
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
  background: ${props => props.type === 'success' ? '#d4edda' : props.type === 'error' ? '#f8d7da' : '#d1ecf1'};
  color: ${props => props.type === 'success' ? '#155724' : props.type === 'error' ? '#721c24' : '#0c5460'};
`;

const DebugAsaas = () => {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const checkEnv = () => {
    const env = {
      REACT_APP_URL_ASAAS: process.env.REACT_APP_URL_ASAAS,
      REACT_APP_APIKEY_ASAAS: process.env.REACT_APP_APIKEY_ASAAS,
      hasUrl: !!process.env.REACT_APP_URL_ASAAS,
      hasKey: !!process.env.REACT_APP_APIKEY_ASAAS,
      keyLength: process.env.REACT_APP_APIKEY_ASAAS?.length,
      keyPrefix: process.env.REACT_APP_APIKEY_ASAAS?.substring(0, 30),
      allReactAppVars: Object.keys(process.env).filter(k => k.startsWith('REACT_APP'))
    };

    setResult({
      type: 'info',
      message: 'Variáveis de Ambiente',
      data: JSON.stringify(env, null, 2)
    });
  };

  const testCreateCustomer = async () => {
    setLoading(true);
    setResult(null);

    const testData = {
      razao_social: 'Empresa Teste Debug LTDA',
      nome_fantasia: 'Debug Test',
      email_responsavel: 'debug@test.com',
      celular_zap_responsavel: '84999887766',
      cnpj: '12345678901234',
      cep: '59000000',
      rua: 'Rua Debug',
      numero: '999',
      bairro: 'Centro',
      complemento: '',
      nome_responsavel: 'Debug User',
      cargo_responsavel: 'Tester'
    };

    try {
      console.log('🧪 Testando criação de cliente...', testData);
      const customer = await asaasService.createCustomer(testData);
      
      setResult({
        type: 'success',
        message: '✅ Cliente criado com sucesso!',
        data: JSON.stringify(customer, null, 2)
      });
    } catch (error) {
      setResult({
        type: 'error',
        message: '❌ Erro ao criar cliente',
        data: `${error.message}\n\nStack:\n${error.stack}`
      });
    } finally {
      setLoading(false);
    }
  };

  const checkLocalStorage = () => {
    const customerId = localStorage.getItem('asaas_customer_id');
    setResult({
      type: 'info',
      message: 'localStorage',
      data: `asaas_customer_id: ${customerId || 'NÃO EXISTE'}`
    });
  };

  const clearLocalStorage = () => {
    localStorage.removeItem('asaas_customer_id');
    setResult({
      type: 'success',
      message: '🗑️ localStorage limpo',
      data: 'asaas_customer_id removido'
    });
  };

  return (
    <Container>
      <Title>🔍 Debug - Integração Asaas</Title>
      
      <div>
        <Button onClick={checkEnv}>1. Verificar Variáveis ENV</Button>
        <Button onClick={checkLocalStorage}>2. Ver localStorage</Button>
        <Button onClick={testCreateCustomer} disabled={loading}>
          {loading ? '⏳ Testando...' : '3. Testar Criar Cliente'}
        </Button>
        <Button onClick={clearLocalStorage}>4. Limpar localStorage</Button>
      </div>

      {result && (
        <Status type={result.type}>
          <h3>{result.message}</h3>
          <Panel>{result.data}</Panel>
        </Status>
      )}

      <div style={{ marginTop: '2rem', padding: '1rem', background: '#fff3cd', borderRadius: '4px' }}>
        <h4>💡 Instruções:</h4>
        <ol>
          <li>Clique em "Verificar Variáveis ENV" - deve mostrar URL e API Key</li>
          <li>Se as variáveis estiverem undefined, reinicie o servidor</li>
          <li>Clique em "Testar Criar Cliente" para testar a API</li>
          <li>Veja o resultado e os logs no console</li>
        </ol>
      </div>
    </Container>
  );
};

export default DebugAsaas;
